import { TrashIcon } from "@heroicons/react/24/outline";
import {
  BadgeButton,
  IconButton,
  ServerSidePaginationButtons
} from "app/components/atoms/button";
import { SearchInput } from "app/components/atoms/input";
import { FormHeader } from "app/components/atoms/layout";
import Table from "app/components/atoms/table";
import Typography from "app/components/atoms/typography";
import { useNavigate } from "react-router-dom";

function CustomerPageTable({
  customers,
  onDeleteCustomerClick = () => {},
  query = "",
  onQueryChange = () => {},
  customerPagination,
  params,
  setParams,
}) {
  const navigate = useNavigate();

  return (
    <Table.Container>
      <Table.UtilitiesWrapper>
        <Table.SearchBarWrapper>
          <FormHeader appearance="none">
            <SearchInput
              placeholder="Search Customer"
              type="text"
              value={query}
              onChange={(e) => { onQueryChange(e.target.value); }}
            />
          </FormHeader>
        </Table.SearchBarWrapper>
        {/* <Table.UtilitiesButtonWrapper>
          <IconButton icon={PrinterIcon} />
        </Table.UtilitiesButtonWrapper> */}
      </Table.UtilitiesWrapper>
      <Table.Wrapper asIndex={true}>
        <Table.Header>
          <Table.HeaderRow>
            <Table.Heading>Nama Lengkap</Table.Heading>
            <Table.Heading>Kontak</Table.Heading>
            <Table.Heading align="right">Kredit</Table.Heading>
            <Table.Heading align="right">Plafon</Table.Heading>
            <Table.Heading></Table.Heading>
          </Table.HeaderRow>
        </Table.Header>
        <Table.Body>
          {customers?.map((customer, key) => (
            <Table.BodyRow key={key}>
              <Table.Cell size="sm">
                <p>
                  {customer?.first_name} {customer?.middle_name}{" "}
                  {customer?.last_name}
                </p>
                <p className="text-xs text-gray-400 font-light">
                  {customer.nick_name}
                </p>
              </Table.Cell>
              <Table.Cell size="sm">
                <div className="block">
                  <p>{customer.phone_number}</p>
                  <p className="text-xs text-gray-400 font-light">
                    {customer.email}
                  </p>
                </div>
              </Table.Cell>
              <Table.Cell size="sm" align="right">
                <Typography.Currency number={customer.credit} />
              </Table.Cell>
              <Table.Cell size="sm" align="right">
                <Typography.Currency number={customer.plafon} />
              </Table.Cell>
              <Table.Cell size="sm">
                <div className="flex">
                  <BadgeButton
                    onClick={(e) => navigate("detail/" + customer.id)}
                  >
                    View
                  </BadgeButton>
                  <IconButton
                    icon={TrashIcon}
                    onClick={(e) => onDeleteCustomerClick(customer.id)}
                  />
                </div>
              </Table.Cell>
            </Table.BodyRow>
          ))}
        </Table.Body>
      </Table.Wrapper>
      <Table.PaginationWrapper>
        <ServerSidePaginationButtons
          paginationProps={customerPagination}
          params={params}
          setParams={setParams}
        />
      </Table.PaginationWrapper>
    </Table.Container>
  );
}

export default CustomerPageTable;
